import { BaseApiResponse } from "../../models/BaseApiResponse";
import { CustomMessagePayload, SegmentedUsersResponse, UserSegmentationFilters } from "../../models/custom-messages";
import { api } from "./api";

export const customMessagesApi = api.injectEndpoints({
  endpoints: (build) => ({
    getSegmentedUsers: build.query<SegmentedUsersResponse, UserSegmentationFilters>({
      query: (filters) => {
        // Crear un objeto limpio solo con los valores definidos
        const cleanFilters: Record<string, any> = {};

        if (filters.email) cleanFilters.email = filters.email;
        if (filters.firstName) cleanFilters.firstName = filters.firstName;
        if (filters.lastName) cleanFilters.lastName = filters.lastName;
        if (filters.birthDateMonth !== undefined) cleanFilters.birthDateMonth = filters.birthDateMonth;
        if (filters.birthDateDay !== undefined) cleanFilters.birthDateDay = filters.birthDateDay;
        if (filters.eventIds && filters.eventIds.length > 0) cleanFilters.eventIds = filters.eventIds;
        if (filters.eventTypeId !== undefined) cleanFilters.eventTypeId = filters.eventTypeId;
        if (filters.eventSubTypeId !== undefined) cleanFilters.eventSubTypeId = filters.eventSubTypeId;
        if (filters.behaviorType) cleanFilters.behaviorType = filters.behaviorType;
        if (filters.tenantId) cleanFilters.tenantId = filters.tenantId;
        if (filters.limit !== undefined) cleanFilters.limit = filters.limit;
        if (filters.offset !== undefined) cleanFilters.offset = filters.offset;

        return {
          url: "/users/segmentation/filter",
          params: cleanFilters,
        };
      },
    }),
    sendCustomMessage: build.mutation<BaseApiResponse<any>, CustomMessagePayload>({
      query: (payload) => ({
        url: "bo/notifications/bulk",
        method: "POST",
        body: payload,
      }),
    }),
  }),
});

export const {
  useGetSegmentedUsersQuery,
  useLazyGetSegmentedUsersQuery,
  useSendCustomMessageMutation
} = customMessagesApi;
